import type { DeepRequired } from '../fixtures.types'

const introducerCommission: DeepRequired<IntroducerCommission> = {
  __typename: 'IntroducerCommission',
  commission_structure_id: 'TEST_ID',
  general_email: null,
  joined_acre: null,
  name: null,
  organisation_id: 'TEST_ID',
  primary_address: null,
  primary_phone: null,
  status: null,
  users: [],
}

export default introducerCommission
